import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PARAMETER_FORM_INSTANCE_ID = "formInstanceId";

export const PATH_EMPLOYEE_TAX_FORMS = "/member/onboarding/tax-forms";
export const PATH_EMPLOYEE_TAX_FORMS_FORM = `${PATH_EMPLOYEE_TAX_FORMS}/:${PARAMETER_FORM_INSTANCE_ID}`;
export const PATH_EMPLOYEE_TAX_FORMS_FORM_RESULT = `${PATH_EMPLOYEE_TAX_FORMS}/:${PARAMETER_FORM_INSTANCE_ID}/result`;

type EmployeeTaxFormsRouteOptions = {
  /**
   * Return path captured when a form is opened from a contractor's requirement
   * details page, so the renderer navigates back there after submit instead of
   * the standalone result screen. Absent in the onboarding flow.
   */
  state: { backPath?: string };
};

export const routeHelpersEmployeeTaxForms = createRouteHelpers<
  never,
  EmployeeTaxFormsRouteOptions
>(PATH_EMPLOYEE_TAX_FORMS);

export const routeHelpersEmployeeTaxFormsForm = createRouteHelpers<
  { formInstanceId: string },
  EmployeeTaxFormsRouteOptions
>(PATH_EMPLOYEE_TAX_FORMS_FORM);

export const routeHelpersEmployeeTaxFormsFormResult = createRouteHelpers<
  { formInstanceId: string },
  EmployeeTaxFormsRouteOptions
>(PATH_EMPLOYEE_TAX_FORMS_FORM_RESULT);
